// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification_container {
  margin: 0 auto;
  margin-top: 16vh;
  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);
  padding: 2rem;
  background-color: var(--ColorPrimary);
  align-items: center;
  justify-content: center;
  display: flex;
}
.notification_details {
  margin: 3rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.notification_details h3 {
  color: var(--ColorSecondaryDark);
}
.notification_details p {
  opacity: 0.7;
}
.notification_details_all {
  margin-left: 5rem;
  padding-left: 3rem;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: "100%";
  border-left: 3px solid var(--ColorSecondaryDark);
}
.notification_details_title {
  margin: 0;
}
.notification_all_box {
  margin-left: 5rem;

  padding: 1rem;
  overflow: auto;
  width: 100%;
}
.notification_box {
  padding: 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.notification_box h3 {
  margin: 0;
  margin-bottom: 1rem;
  color: var(--ColorSecondaryDark);
}
.notification_box p {
  margin: 0;
}

.image_notification {
  transform: scale(0);
}

.form_notification {
  transform: scaleY(0);
}

.form_animation {
  display: block;
  animation-name: scale-up-ver-top;
  animation-duration: 1s;
}

.image_animation {
  display: block;
  animation-name: scale-up-tr;
  animation-duration: 1s;
}

@keyframes scale-up-tr {
  0% {
    transform: scale(0.5);
    transform-origin: 100% 0%;
  }
  100% {
    transform: scale(1);
    transform-origin: 100% 0%;
  }
}
@keyframes scale-up-ver-top {
  0% {
    transform: scaleY(0.4);
    transform-origin: 100% 0%;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 100% 0%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NotificationSenderPage/notificationPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;;EAEjB,aAAa;EACb,cAAc;EACd,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE;IAEE,qBAAqB;IAErB,yBAAyB;EAC3B;EACA;IAEE,mBAAmB;IAEnB,yBAAyB;EAC3B;AACF;AACA;EACE;IAEE,sBAAsB;IAEtB,yBAAyB;EAC3B;EACA;IAEE,oBAAoB;IAEpB,yBAAyB;EAC3B;AACF","sourcesContent":[".notification_container {\n  margin: 0 auto;\n  margin-top: 16vh;\n  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);\n  padding: 2rem;\n  background-color: var(--ColorPrimary);\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n.notification_details {\n  margin: 3rem;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.notification_details h3 {\n  color: var(--ColorSecondaryDark);\n}\n.notification_details p {\n  opacity: 0.7;\n}\n.notification_details_all {\n  margin-left: 5rem;\n  padding-left: 3rem;\n  max-height: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: \"100%\";\n  border-left: 3px solid var(--ColorSecondaryDark);\n}\n.notification_details_title {\n  margin: 0;\n}\n.notification_all_box {\n  margin-left: 5rem;\n\n  padding: 1rem;\n  overflow: auto;\n  width: 100%;\n}\n.notification_box {\n  padding: 2%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.notification_box h3 {\n  margin: 0;\n  margin-bottom: 1rem;\n  color: var(--ColorSecondaryDark);\n}\n.notification_box p {\n  margin: 0;\n}\n\n.image_notification {\n  transform: scale(0);\n}\n\n.form_notification {\n  transform: scaleY(0);\n}\n\n.form_animation {\n  display: block;\n  animation-name: scale-up-ver-top;\n  animation-duration: 1s;\n}\n\n.image_animation {\n  display: block;\n  animation-name: scale-up-tr;\n  animation-duration: 1s;\n}\n\n@keyframes scale-up-tr {\n  0% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n  }\n}\n@keyframes scale-up-ver-top {\n  0% {\n    -webkit-transform: scaleY(0.4);\n    transform: scaleY(0.4);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n  }\n  100% {\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
